module.exports = __webpack_public_path__ + "a8fe502aec263344e0121a20da91ee12.svg";